import { Alert } from '@statsbomb/kitbag-components';
import {
  _VideoPlayer,
  useVideoCanPlay,
  useVideoControls,
} from '@statsbomb/video-client-js';
import PropTypes from 'prop-types';
import qs from 'qs';
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import ErrorText from '../../components/ErrorText';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import useClearPlaylist from '../../hooks/clearPlaylistOnLoad';

const toBoolean = (value) => !!(value && JSON.parse(value));

export function Embed() {
  const { sport, matchId, period } = useParams();
  const { search } = useLocation();
  const query = qs.parse(search, { ignoreQueryPrefix: true });

  const { streamsOnly, muted, starttime } = query;
  const allowStreamsOnly = toBoolean(streamsOnly);
  const muteVideo = toBoolean(muted);
  const startTime = starttime ? Number(starttime) : null;

  return (
    <EmbedDisplay
      matchId={matchId}
      muted={muteVideo}
      period={period}
      search={search}
      startTime={startTime}
      streamsOnly={allowStreamsOnly}
      sport={sport}
    />
  );
}

export function EmbedDisplay({
  matchId,
  muted,
  period,
  search,
  sport,
  startTime,
  streamsOnly,
}) {
  useClearPlaylist();
  const api = useApi();
  const canPlay = useVideoCanPlay();
  const { setCurrentTime } = useVideoControls();
  const hasSeekRef = useRef(false);

  const type = streamsOnly ? 'streams' : 'urls';
  useEffect(() => {
    api.get(
      `${API_ENDPOINTS.videoService}/${sport}/${matchId}/${period}/${type}${search}`,
    );
  }, []);

  const src = (api.response?.data?.urls || [])[0];

  useEffect(() => {
    if (src && canPlay && startTime !== null && !hasSeekRef.current) {
      hasSeekRef.current = true;
      setCurrentTime(startTime);
    }
  }, [src, canPlay]);

  return (
    <>
      {api.errorMessage && <ErrorText errorMessage={api.errorMessage} />}
      {!src ||
        (api.isFetching && (
          <Alert>
            <FormattedMessage
              defaultMessage="We're finding your video. Please wait..."
              description="Finding video"
              id="2502a"
            />
          </Alert>
        ))}
      {/* Disabled as known prefix for dev only internal components */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <_VideoPlayer autoPlay={!!src} controls muted={muted} src={src} />
    </>
  );
}

EmbedDisplay.propTypes = {
  matchId: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  period: PropTypes.string.isRequired,
  search: PropTypes.string,
  sport: PropTypes.string.isRequired,
  startTime: PropTypes.number,
  streamsOnly: PropTypes.bool,
};

EmbedDisplay.defaultProps = {
  muted: false,
  search: '',
  startTime: null,
  streamsOnly: false,
};

export default { Embed };
